<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
            title="جزئیات اسلایدر"
        >
          <b-form @submit.prevent>
            <b-row>
              <b-col
                class="mt-2"
                md="8"
                offset-md="2"
              >
                <b-row>
                  <b-col class="col-md-12 mb-1">
                    <fm-file-select v-model="form.Image" label="عکس" :entity="entity" />
                  </b-col>
                  <b-col class="col-md-12 mb-1">
                    <fm-file-select v-model="form.MobileImage" label="عکس موبایل" :entity="entity" />
                  </b-col>
                  <b-col md="6" class="mb-1">
                    <b-form-group
                        label="عنوان"
                        label-for="Title"
                    >
                      <b-form-input
                          id="Title"
                          v-model="form.Title"
                          autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col md="6" class="mb-1">
                    <b-form-group
                        label="شناسه"
                        label-for="TagId"
                    >
                      <b-form-input
                          id="TagId"
                          v-model.number="form.TagId"
                          type="number"
                          autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col class="col-md-6 mb-1">
                    <b-form-group
                        label="نوع نمایش"
                        label-for="ViewType"
                        class="d-inline-block full-width"
                    >
                      <v-select
                          id="ViewType"
                          v-model="form.ViewType"
                          dir="rtl"
                          :reduce="x => x.value"
                          label="text"
                          input-id="ViewType"
                          :clearable="false"
                          :options="enums('blogBannersViewType').filter(option => option.value !== null)"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col class="col-md-6 mb-1">
                    <b-form-group
                        label="محل نمایش"
                        label-for="PlaceType"
                        class="d-inline-block full-width"
                    >
                      <v-select
                          id="PlaceType"
                          v-model="form.PlaceType"
                          dir="rtl"
                          :reduce="x => x.value"
                          label="text"
                          input-id="PlaceType"
                          :clearable="false"
                          :options="enums('placeType').filter(option => option.value !== null)"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col class="col-md-6 mb-1">
                    <b-form-group
                      label="از تاریخ"
                      label-for="StartDate"
                    >
                      <date-picker
                        v-model="form.StartDate"
                        placeholder=""
                        type="date"
                        format="YYYY-MM-DD"
                        display-format="jYYYY-jMM-jD"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col class="col-md-6 mb-1">
                    <b-form-group
                      label="تا تاریخ"
                      label-for="EndDate"
                    >
                      <date-picker
                        v-model="form.EndDate"
                        placeholder=""
                        type="date"
                        format="YYYY-MM-DD"
                        display-format="jYYYY-jMM-jD"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6" class="mb-1">
                    <b-form-group
                        label="مقدار ثانیه تا نمایش"
                        label-for="Url"
                    >
                      <b-form-input
                          id="Url"
                          v-model="form.SecondToShow"
                          autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="6" class="mb-1">
                    <b-form-group
                        label="مقدار اسکرول تا نمایش"
                        label-for="Url"
                    >
                      <b-form-input
                          id="Url"
                          v-model="form.ScrollToShow"
                          autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="12" class="mb-1">
                    <b-form-group
                        label="لینک"
                        label-for="Url"
                    >
                      <b-form-input
                          id="Url"
                          v-model="form.URL"
                          dir="ltr"
                          autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col class="col-md-12 mb-1">
                    <b-form-group
                        label="تگ"
                        label-for="Tag"
                        class="d-inline-block full-width"
                    >
                      <sliderTagSelector v-model="form.Tags" multiple></sliderTagSelector>
                    </b-form-group>
                  </b-col>

                <b-col md="12" class="mb-1">
                  <b-form-group
                      label="متن"
                      label-for="Description"
                  >
                    <b-form-textarea
                        id="Description"
                        v-model="form.Description"
                        name="Description"
                        rows="3"
                    />
                  </b-form-group>
                </b-col>

                  <b-col cols="12">
                    <b-form-group class="mt-1">
                      <b-form-checkbox
                          v-model="form.IsActive"
                          class="custom-control-success"
                      >
                        فعال
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <b-form-group class="mt-1">
                      <b-form-checkbox
                          v-model="form.ShowInDesktop"
                          value="true"
                          class="custom-control-success"
                      >
                        نمایش در حالت دسکتاپ
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <b-form-group class="mt-1">
                      <b-form-checkbox
                          v-model="form.ShowInMobile"
                          value="true"
                          class="custom-control-success"
                      >
                        نمایش در حالت موبایل
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>

                <b-col class="mt-1 mb-2 text-center">
                  <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="submit"
                  >
                    ذخیره
                  </b-button>
                  <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                  >
                    بازگشت
                  </b-button>
                </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
import FmFileSelect from "@/views/menu/file-manager/components/fmFileSelect.vue";
import DynamicSelect from '@/tools/dynamicSelect.vue'
import sliderTagSelector from '@/tools/sliderTagSelector.vue'
const ENTITY_SLIDER = 13

export default {
  name: 'SliderDetails',
  components: { FmFileSelect, DynamicSelect, sliderTagSelector },
  data() {
    return {
      loading: false,
      entity: ENTITY_SLIDER,
      form: {
        Title: null,
        URL: null,
        PlaceType: null,
        ViewType: null,
        Description: '',
        StartDate: null,
        EndDate: null,
        IsActive: true,
        TagId: null,
        Image: null,
        MobileImage: null,
        ShowInDesktop: false,
        ShowInMobile: false,
        SecondToShow: '',
        ScrollToShow: '',
        Tags: []
      },
      data: null
    }
  },
  computed: {
    isValid() {
      let valid = true
      let requiredItems = ['Title', 'URL', 'Image', 'StartDate', 'EndDate']
      requiredItems.forEach(key => {
        if (this.form[key] === null || this.form[key] === '') valid = false
      })
      return valid
    },
    editing() {
      return this.$route.params.id
    }
  },
  watch: {
    editing: {
      immediate: true,
      handler(val) {
        if (val) this.getData()
      }
    }
  },
  methods: {
    submit() {
      if (!this.isValid) return
      let form = { ...this.form }
      if (this.editing) form.Id = this.editing

      this.loading = true

      let url = this.editing ? this.$api.slider.edit : this.$api.slider.add

      this.$http.post(url, form).then(() => {
        this.loading = false
        this.back()
      }).finally(() => {
        this.loading = false
      })
    },
    getData() {
      this.loading = true
      this.$http.post(this.$api.slider.get, { Id: this.editing }).then(response => {
        this.loading = false
        this.form = response.data
      }).finally(() => {
        this.loading = false
      })
    }
  },
}
</script>
